export class Exception {
  constructor (public msg: string, public error) {
    this.msg = msg
    this.error = error
  }
}
